import api from './api';
import api2 from './api2';

export function valideteClientAdvisor(tipoIdentificacion, identificacion, idAsesor) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/clientes/${tipoIdentificacion}/${identificacion}/validar-asesor/${idAsesor}`);
}

export function clientRegister(data, idSimulacion) {
  return api({
    method: 'post',
    url: `${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/simulaciones/${idSimulacion}/clientes`,
    headers: {
      "content-type": "form-data"
    },
    data: data,
  });
}

export function endClienteRegistration(data, idCredit) {
  return api({
    method: 'post',
    url: `${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/${idCredit}/clients/finalize`,
    headers: {
      "content-type": "form-data"
    },
    data: data,
  });
}

export function clientOnlyRegister(data, idSimulacion) {
  return api({
    method: 'post',
    url: `${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/simulaciones/${idSimulacion}/clientes-vi`,
    headers: {
      "content-type": "form-data"
    },
    data: data,
  });
}

export function clientOnlyUpdate(data, idSimulacion) {
  return api({
    method: 'patch',
    url: `${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/simulaciones/${idSimulacion}/clientes-vi`,
    headers: {
      "content-type": "form-data"
    },
    data: data,
  });
}

export function creditRegister(data, idSimulacion) {
  return api({
    method: 'post',
    url: `${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/simulaciones/${idSimulacion}/credito`,
    headers: {
      "content-type": "form-data"
    },
    data: data,
  });
}

export function valideteClientAdvisorWithoutModal(tipoIdentificacion, identificacion, idAsesor) {
  return api2.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/clientes/${tipoIdentificacion}/${identificacion}/validar-asesor/${idAsesor}`);
}

export function validateClientAdvisorPaymentBill(data) {
  return api2.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/clientes/validar-asesor`,data);
}

export function validateClientAdvisorPaymentBillError(data) {
  return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/clientes/validar-asesor`,data);
}
